import GenericTheme from "./Generic";
import KidsTheme1 from "./Kids";
import KidsTheme2 from "./Kids2";
import PeaceLoveTheme from "./PeaceLove";
import Alternate2 from "./Alternate2";

export const availableThemes = [
  {
    text: "Default",
    link: "#",
    action: "",
  },
  {
    text: "Children's 1",
    link: "#",
    action: "",
  },
  {
    text: "Children's 2",
    link: "#",
    action: "",
  },
  {
    text: "Alternate 1",
    link: "#",
    action: "",
  },
  {
    text: "Alternate 2",
    link: "#",
    action: "",
  },
];

export function getTheme(themeKey) {
  switch (themeKey) {
    case "Children's 1":
      return KidsTheme1;
    case "Children's 2":
      return KidsTheme2;
    case "Alternate 1":
      return PeaceLoveTheme;
    case "Alternate 2":
      return Alternate2;
    default:
      return GenericTheme;
  }
}
